import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import useAuth from '@hooks/useAuth';
import { Link } from 'react-router-dom';
import Button from "react-bootstrap/Button";

function MyNavbar() {
    const { signUserOut } = useAuth();

    return (
        <Navbar bg="dark" data-bs-theme="dark">
            <Container>
                <Navbar.Brand href="/">
                    <div className="image-container">
                        <img
                            src={require("@assets/logo/logo_main.png")}
                            alt='IsolierAllianz Logo'
                            className="preview-image"
                        />
                    </div>
                </Navbar.Brand>
                <Nav className="me-auto d-flex align-items-center gap-4">
                    <Link className='m-0 text-decoration-none text-white' to="/">Projekte</Link>
                    <Link className='m-0 text-decoration-none text-white' to="/mitarbeiter">Mitarbeiter</Link>
                    <Link className='m-0 text-decoration-none text-white' to="/projekte-ubersicht">Übersicht</Link>
                    <Link className='m-0 text-decoration-none text-white' to="/ladezone-belegung">Ladezone-Belegung</Link>
                    <Link className='m-0 text-decoration-none text-white' to="/archiv">Archiv</Link>
                    <Button onClick={signUserOut} variant="danger">
                        Ausloggen
                    </Button>
                </Nav>
            </Container>
        </Navbar>
    );
}

export default MyNavbar;